// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvideo[data-v-8f33873a] {\n\tbackground-color: black;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\talign-self: center;\n\tjustify-self: center;\n\t/* over arrows in tiny screens */\n\tz-index: 20050;\n}\n", ""]);
// Exports
module.exports = exports;
